/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.querySelectorAll("select").forEach(select => {
  select.addEventListener("change", function () {
    const wrapper = this.closest(".select-wrapper");
    const placeholder = wrapper.querySelector(".dummyplaceholder");
    if (placeholder) {
      placeholder.style.display = "none";
    }
  });
});

$(document).ready(function () {
  // document.addEventListener('variant:changed', function(event) {
  //   let variant = event.detail.variant; // Gives you access to the whole variant details
  //   let form = event.target;
  //   if(document.querySelector('[data-vartitle]')){
  //     document.querySelector('[data-vartitle]').innerHTML = `- ${variant.title}`;
  //   }
  // });
  $(".banner-slideshow_image-slider").slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay:true,
    fade:true,
    slidesToShow: 1,
    slidesToScroll: 1,
    // asNavFor: '.banner-slideshow_text-column-wrapper'
  });
  // $(".banner-slideshow_text-column-wrapper").slick({
  //   dots: false,
  //   arrows: false,
  //   infinite: true,
  //   autoplay:true,
  //   fade:true,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   asNavFor: '.banner-slideshow_image-slider'
  // });
  $(".testimonial_wrapper").slick({
    dots: true,
    arrows: true,
    infinite: false,
    autoplay:false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          arrows: false,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 740,
        settings: {
          arrows: false,
          slidesToShow: 1
        }
      }
    ]
  });
  $(".article-list_wrapper").slick({
    dots: true,
    arrows: true,
    infinite: false,
    autoplay:false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          arrows: false,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 740,
        settings: {
          arrows: false,
          slidesToShow: 1
        }
      }
    ]
  });
  $(".steps-row").slick({
    dots: true,
    arrows: true,
    infinite: false,
    autoplay:false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          arrows: false,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 740,
        settings: {
          arrows: false,
          slidesToShow: 1
        }
      }
    ]
  });
  
  function duolingo_fields(_this){
    let value = $(_this).val();
    if(value == 'CEFR'){
      var listbasehtml = `<div class="input select-input dynamic-field onchange-field">
                      <div class="select-wrapper">
                        <select class="select" exam-dynamic-dropdown name="duo_convert_score" id="cefr_score">
                          <option value="" disabled selected hidden></option>
                          <option value="A1-A2">A1-A2</option>
                          <option value="B1">B1</option>
                          <option value="B2">B2</option>
                          <option value="C1">C1</option>
                          <option value="C2">C2</option>
                        </select>
                        <svg focusable="false" width="12" height="8" class="icon icon--chevron" viewBox="0 0 12 8">
                          <path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2"></path>
                        </svg>

                      </div>
                      <label for="cefr_score" class="input__label">Your CEFR Score</label>
                    </div>`;
    }else if(value == 'IELTS'){
      var listbasehtml = `<div class="input select-input dynamic-field onchange-field">
                      <div class="select-wrapper">
                        <select class="select" exam-dynamic-dropdown name="duo_convert_score" id="duolingo_ielts_score">
                          <option value="" disabled selected hidden></option>
                          <option value="0">0</option>
                          <option value="0.5">0.5</option>
                          <option value="1.0">1.0</option>
                          <option value="1.5">1.5</option>
                          <option value="2.0">2.0</option>
                          <option value="2.5">2.5</option>
                          <option value="3.0">3.0</option>
                          <option value="3.5">3.5</option>
                          <option value="4.0">4.0</option>
                          <option value="4.5">4.5</option>
                          <option value="5.0">5.0</option>
                          <option value="5.5">5.5</option>
                          <option value="6.0">6.0</option>
                          <option value="6.5">6.5</option>
                          <option value="7.0">7.0</option>
                          <option value="7.5">7.5</option>
                          <option value="8.0">8.0</option>
                          <option value="8.5">8.5</option>
                          <option value="9.0">9.0</option>
                        </select>
                        <svg focusable="false" width="12" height="8" class="icon icon--chevron" viewBox="0 0 12 8">
                          <path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2"></path>
                        </svg>

                      </div>
                      <label for="duolingo_ielts_score" class="input__label">Your IELTS Band</label>
                    </div>`;
    }else if(value == 'PTE'){
      var listbasehtml = `<div class="input select-input dynamic-field onchange-field">
                      <div class="select-wrapper">
                        <select class="select" exam-dynamic-dropdown name="duo_convert_score" id="duolingo_pte_score">
                          <option value="" disabled selected hidden></option>
                          <option value="10-23">10-23</option>
                          <option value="24-30">24-30</option>
                          <option value="31-38">31-38</option>
                          <option value="39-46">39-46</option>
                          <option value="47-54">47-54</option>
                          <option value="55-62">55-62</option>
                          <option value="63-70">63-70</option>
                          <option value="71-78">71-78</option>
                          <option value="79-85">79-85</option>
                          <option value="86-89">86-89</option>
                          <option value="89-90">89-90</option>
                        </select>
                        <svg focusable="false" width="12" height="8" class="icon icon--chevron" viewBox="0 0 12 8">
                          <path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2"></path>
                        </svg>

                      </div>
                      <label for="duolingo_pte_score" class="input__label">Your PTE Score</label>
                    </div>`;
    }else if(value == 'TOEFL'){
      var listbasehtml = `<div class="input select-input dynamic-field onchange-field">
                      <div class="select-wrapper">
                        <select class="select" exam-dynamic-dropdown name="duo_convert_score" id="duolingo_toefl_score">
                          <option value="" disabled selected hidden></option>
                          <option value="0-25">0-25</option>
                          <option value="26-36">26-36</option>
                          <option value="37-50">37-50</option>
                          <option value="51-66">51-66</option>
                          <option value="67-80">67-80</option>
                        </select>
                        <svg focusable="false" width="12" height="8" class="icon icon--chevron" viewBox="0 0 12 8">
                          <path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2"></path>
                        </svg>

                      </div>
                      <label for="duolingo_toefl_score" class="input__label">Your TOEFL Score</label>
                    </div>`;
    }
    
    var $wrapper = $(_this).closest('.input-row-custom');
    // Remove previously added inputs but keep the select
    $wrapper.find('.input.onchange-field').remove();
    $wrapper.append(listbasehtml);
  }

  function appendfields(value, $wrapper){

    let inputshtml = "";

    if (value === "PTE Academic") {
      inputshtml = `<div class="input dynamic-field">
                      <input id="pte_score" type="text" class="input__field input__field--text" name="pte_score">
                      <label for="pte_score" class="input__label">Enter Your PTE Score</label>
                    </div>`;
      } else if (value === "PTE Core") {
        inputshtml = `<div class="input select-input dynamic-field">
        <div class="select-wrapper">
          <select class="select" exam-dynamic-dropdown name="listening_clb" id="listening_clb">
            <option value="" disabled selected hidden></option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </select>
          <svg focusable="false" width="12" height="8" class="icon icon--chevron" viewBox="0 0 12 8">
            <path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2"></path>
          </svg>

        </div>
        <label for="listening_clb" class="input__label">Your Listening CLB Score</label>
      </div>

      <div class="input select-input dynamic-field">
        <div class="select-wrapper">
          <select class="select" exam-dynamic-dropdown name="reading_clb" id="reading_clb">
            <option value="" disabled selected hidden></option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </select>
          <svg focusable="false" width="12" height="8" class="icon icon--chevron" viewBox="0 0 12 8">
            <path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2"></path>
          </svg>

        </div>
        <label for="reading_clb" class="input__label">Your Reading CLB Score</label>
      </div>

      <div class="input select-input dynamic-field">
        <div class="select-wrapper">
          <select class="select" exam-dynamic-dropdown name="speaking_clb" id="speaking_clb">
            <option value="" disabled selected hidden></option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </select>
          <svg focusable="false" width="12" height="8" class="icon icon--chevron" viewBox="0 0 12 8">
            <path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2"></path>
          </svg>

        </div>
        <label for="speaking_clb" class="input__label">Your Speaking CLB Score</label>
      </div>

      <div class="input select-input dynamic-field">
        <div class="select-wrapper">
          <select class="select" exam-dynamic-dropdown name="writing_clb" id="writing_clb">
            <option value="" disabled selected hidden></option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </select>
          <svg focusable="false" width="12" height="8" class="icon icon--chevron" viewBox="0 0 12 8">
            <path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2"></path>
          </svg>

        </div>
        <label for="writing_clb" class="input__label">Your Writing CLB Score</label>
      </div>`;
      } else if (value === "GRE") {
        inputshtml = `<div class="input dynamic-field">
                      <input id="verbal_reasoning_percentile" type="text" class="input__field input__field--text" name="verbal_reasoning_percentile">
                      <label for="verbal_reasoning_percentile" class="input__label">Enter Your Verbal Reasoning Percentile</label>
                    </div>
                    <div class="input dynamic-field">
                      <input id="quantitative_reasoning_percentile" type="text" class="input__field input__field--text" name="quantitative_reasoning_percentile">
                      <label for="quantitative_reasoning_percentile" class="input__label">Enter Your Quantitative Reasoning Percentile</label>
                    </div>
                    <div class="input dynamic-field">
                      <input id="analytical_writing_percentile" type="text" class="input__field input__field--text" name="analytical_writing_percentile">
                      <label for="analytical_writing_percentile" class="input__label">Enter Your Analytical Writing Percentile</label>
                    </div>`;
      
    } else if (value === "IELTS") {
      
      inputshtml = `<div class="input select-input dynamic-field">
        <div class="select-wrapper">
          <select class="select" exam-dynamic-dropdown name="ielts_score" id="ielts_score">
            <option value="" disabled selected hidden></option>
            <option value="0">0</option>
            <option value="0.5">0.5</option>
            <option value="1.0">1.0</option>
            <option value="1.5">1.5</option>
            <option value="2.0">2.0</option>
            <option value="2.5">2.5</option>
            <option value="3.0">3.0</option>
            <option value="3.5">3.5</option>
            <option value="4.0">4.0</option>
            <option value="4.5">4.5</option>
            <option value="5.0">5.0</option>
            <option value="5.5">5.5</option>
            <option value="6.0">6.0</option>
            <option value="6.5">6.5</option>
            <option value="7.0">7.0</option>
            <option value="7.5">7.5</option>
            <option value="8.0">8.0</option>
            <option value="8.5">8.5</option>
            <option value="9.0">9.0</option>
          </select>
          <svg focusable="false" width="12" height="8" class="icon icon--chevron" viewBox="0 0 12 8">
            <path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2"></path>
          </svg>

        </div>
        <label for="ielts_score" class="input__label">Your IELTS Band</label>
      </div>`;

    } else if (value === "TOEFL") {
      inputshtml = `<div class="input dynamic-field">
                      <input id="toefl_score" type="text" class="input__field input__field--text" name="toefl_score">
                      <label for="toefl_score" class="input__label">Enter Your TOEFL Score</label>
                    </div>`;

    } else if (value === "Duolingo") {
      
      var duolingovalues = '';
      for(var i = 2;i<=32;i++){
        var vall = i * 5;
          duolingovalues += `<option value="${vall}">${vall}</option>`;
      }
      
      inputshtml = `<div class="input select-input dynamic-field">
                      <div class="select-wrapper">
                        <select class="select" name="duolingo_exam_list" duolingo_exam_list id="duolingo_exam_list">
                          <option value="" disabled selected hidden></option>
                          <option value="CEFR" data-opt-title="cefr">CEFR</option>
                          <option value="IELTS" data-opt-title="ielts">IELTS</option>
                          <option value="PTE" data-opt-title="pte">PTE</option>
                          <option value="TOEFL" data-opt-title="toefl">TOEFL</option>
                        </select>
                        <svg focusable="false" width="12" height="8" class="icon icon--chevron   " viewBox="0 0 12 8">
                          <path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2"></path>
                        </svg>

                      </div>
                      <label for="duolingo_exam_list" class="input__label">Select Exam to convert score</label>
                    </div>
                    
                    <div class="input select-input dynamic-field">
                      <div class="select-wrapper">
                        <select class="select" name="duolingo_score" id="duolingo_score">
                          <option value="" disabled selected hidden></option>
                          ${duolingovalues}
                        </select>
                        <svg focusable="false" width="12" height="8" class="icon icon--chevron" viewBox="0 0 12 8">
                          <path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2"></path>
                        </svg>

                      </div>
                      <label for="duolingo_score" class="input__label">Your Duolingo Score</label>
                    </div>`;
    }

    // Append new fields after the select input
    $wrapper.append(inputshtml);

    if(localStorage.getItem("examData")){
      var savedData = JSON.parse(localStorage.getItem("examData"));
      if(savedData.examname == 'duolingo'){
        $wrapper.find('[name="duolingo_exam_list"]')
        .on('change', function() {
          console.log(this);
          duolingo_fields(this);
          $wrapper.find('[exam-dynamic-dropdown]').val(savedData.resultscore).trigger('change').closest('.select-wrapper').addClass('is-filled');
        })
        .val(
          $wrapper.find('[name="duolingo_exam_list"] option[data-opt-title="'+savedData.covertedexam+'"]').attr('value')
        )
        .trigger('change').closest('.select-wrapper').addClass('is-filled');
        $wrapper.find('[name="duolingo_score"]').val(savedData.score).trigger('change').closest('.select-wrapper').addClass('is-filled');
        $wrapper.find('[name="cefr_score"]').val(savedData.cefrscore).trigger('change').closest('.select-wrapper').addClass('is-filled');
      }else if(savedData.examname == 'ielts'){
        $wrapper.find('[name="ielts_score"]').val(savedData.score).trigger('change').closest('.select-wrapper').addClass('is-filled');
      }else if(savedData.examname == 'toefl'){
        $wrapper.find('[name="toefl_score"]').val(savedData.score).addClass('is-filled');
      }else if(savedData.examname == 'gre'){
        $wrapper.find('[name="verbal_reasoning_percentile"]').val(savedData.verbal_reasoning).addClass('is-filled');
        $wrapper.find('[name="quantitative_reasoning_percentile"]').val(savedData.quantitativ_reasoning).addClass('is-filled');
        $wrapper.find('[name="analytical_writing_percentile"]').val(savedData.analytical_writing).addClass('is-filled');
      }else if(savedData.examname == 'pte'){
        $wrapper.find('[name="pte_score"]').val(savedData.score).addClass('is-filled');
      }else if(savedData.examname == 'pte_core'){
        $wrapper.find('[name="listening_clb"]').val(savedData.listening).trigger('change').closest('.select-wrapper').addClass('is-filled');
        $wrapper.find('[name="reading_clb"]').val(savedData.reading).trigger('change').closest('.select-wrapper').addClass('is-filled');
        $wrapper.find('[name="speaking_clb"]').val(savedData.speaking).trigger('change').closest('.select-wrapper').addClass('is-filled');
        $wrapper.find('[name="writing_clb"]').val(savedData.writing).trigger('change').closest('.select-wrapper').addClass('is-filled');
      }
    }
  }

  // Pre-select from localStorage
  if (localStorage.getItem("examData")) {
    if ($('[data-admission-support-form]').length > 0) {
      var savedData = JSON.parse(localStorage.getItem("examData"));
      var examname = savedData.examname;
      var selectedVal = $('[data-english-text] option[data-opt-title="'+examname+'"]').val();
      var $wrapper = $('[data-english-text]').closest('.input-row-custom');
      if (selectedVal) {
        $('[data-english-text]').val(selectedVal).trigger('change').closest('.select-wrapper').addClass('is-filled');
        appendfields(selectedVal, $wrapper);
      }
    }
  }

  $('body').on('click','.article__content .onthispage_list_wrapper a', function(){
    var selectr = $(this).attr('data-toscroll');
    var mm = $(this).closest('.article__content').find('.body_content .'+selectr);
    if(mm.length > 0){
     window.scrollTo({top: mm.offset().top - parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height")), behavior: 'smooth'});
    }    
  });

  $(document).on('scroll', function(){
    if($(window).scrollTop() > 100){
      $('.scrolltotop_button').addClass('show');
    }else{
      $('.scrolltotop_button').removeClass('show');
    }
  });

  $('body').on('click', '.scrolltotop_button', function(){
    window.scrollTo({top: 0, behavior: 'smooth'});
  });

  $('body').on('click', '.hideshow_button', function(){
    if($(this).closest('.onthispage_list_wrapper').find('.pagelist_main').is(':visible')){
      $(this).html('[Show]');
    }else{
      $(this).html('[Hide]');
    }
    $(this).closest('.onthispage_list_wrapper').find('.pagelist_main').toggle();
  });

  // Change handler
  $('body').on('change', '[data-english-text]', function() {
    console.log('triggered')
    var $wrapper = $(this).closest('.input-row-custom');
    // Remove previously added inputs but keep the select
    $wrapper.find('.input.dynamic-field').remove();
    let value = $(this).val();
    appendfields(value,$wrapper);
  });

  $('body').on('change', '[duolingo_exam_list]', function() {
    duolingo_fields(this);
  });

  $('body').on('click','.account .resend-exam-voucher', function(e){
   e.preventDefault();
   var order_id = $(this).attr('order_id');
   var phone = $(this).attr('phone');
   var email = $(this).attr('email');
   var name = $(this).attr('name');
   $(this).next('.cart-popover').addClass('active');
   fetch('https://eduvouchers.ekarostats.com/api/orders/resend-postback', {
      method: 'POST',
      headers: {
          'x-api-key': 'K6908y767hsjjdejEotwleAo',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
          "order_id": order_id,
          "mobile": phone,
          "email": email,
          "name": name
      })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return response.json();
    })
    .then(data => {
      console.log('this:');
      $(this).next('.cart-popover').find('.cart-popover_resend-cont').html(`
          <svg width="92" height="88" viewBox="0 0 92 88" fill="none" xmlns="http://www.w3.org/2000/svg" class="">
            <path d="M91.8317 44L81.665 32.375L83.0817 17L68.04 13.5833L60.165 0.25L45.9984 6.33333L31.8317 0.25L23.9567 13.5417L8.91504 16.9167L10.3317 32.3333L0.165039 44L10.3317 55.625L8.91504 71.0417L23.9567 74.4583L31.8317 87.75L45.9984 81.625L60.165 87.7083L68.04 74.4167L83.0817 71L81.665 55.625L91.8317 44ZM38.04 63.6667L22.2067 47.7917L28.3734 41.625L38.04 51.3333L62.415 26.875L68.5817 33.0417L38.04 63.6667Z" fill="#26A651"/>      
          </svg>
          <div class="h6 resend-exam-voucher_popup-title"><strong>Voucher Successfully Sent</strong></div>
          <div>We’ve successfully sent your voucher to ${email} & ${phone}.</div>
      `);
      setTimeout(function(){
        $('.cart-popover').removeClass('active');
      }, 10000); 
    })
    .catch(error => {
        console.error('Error:', error);
    });
  });   
  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
    }

  $('.cart-popover_close,.cart-popover_overlay,.cart-popover_submit').click(function(e){
      e.preventDefault();
      $(this).parents('.cart-popover').removeClass('active');
  })
  $('.cart-popover .cart-mandatory-radio_field input[type="radio"] + label').click(function(){
    $(this).parents('.cart-popover').removeClass('active');
  })
  $('.cart-mandatory-select').click(function(e){
      e.preventDefault();
      $(this).next('.cart-popover').addClass('active');
  })

  $("body").on("keyup", ".course-calculator-main #calculator_search", function() {
    var value = $(this).val().toLowerCase();

    $(this).closest('.course-calculator-main').find('.pages_block_wp').each(function(){
      var cnnt = 0
      $(this).find('.calculator-card').filter(function() {
        if($(this).find('.calculator-content').text().toLowerCase().indexOf(value) > -1){
          $(this).toggle(true);
          cnnt += 1;
        }else{
          $(this).toggle(false);
        }
      });
      if(cnnt == 0){
        $(this).hide();
      }else{
        $(this).show(); 
      }
    });
    
  });


  $("body").on("click","[data-admissionform-submit]", function(e){
    e.preventDefault();
    
    var _this = $(this);
    let isValid = true;
    let firstError = null;

    // Reset previous error states
    $(".input__field, .select, textarea, .checkbox").removeClass("field-error");
    $(".form_error_msg").remove();
    $(".form_success_msg").remove();

    // Validate all required fields
    $(".form-fields-wrapper [required]").each(function(){
      let $field = $(this);
      let value = $.trim($field.val());

      if($field.is(":checkbox")){
        if(!$field.is(":checked")){
          isValid = false;
          showError($field, "This field is required");
        }
      } 
      else if($field.is("select")){
        if(value === "" || value === null){
          isValid = false;
          showError($field, "Please select an option");
        }
      } 
      else {
        if(value === ""){
          isValid = false;
          showError($field, "This field is required");
        }
      }

      // Special validation for email
      if($field.attr("name") === "email" && value !== ""){
        let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(!emailPattern.test(value)){
          isValid = false;
          showError($field, "Enter a valid email address");
        }
      }

      // Special validation for phone
      if($field.attr("name") === "phone_number" && value !== ""){
        let phonePattern = /^[0-9]{7,15}$/; 
        if(!phonePattern.test(value)){
          isValid = false;
          showError($field, "Enter a valid phone number");
        }
      }

      // Track first error to focus
      if(!isValid && firstError === null){
        firstError = $field;
      }
    });

    // Focus first error field
    if(firstError){
      $(this).before('<p class="form_error_msg">Please fill in all required fields before submitting the form.</p>');
      // firstError.focus();
    }

    if(isValid){
      if(_this.hasClass('data-admission-support')){
        var api = `https://edudialer.ekarostats.com/api/user/create_admission`;
        var data = {
            "contact": `${_this.closest('[data-admission-support-form]').find('[name="phone_number"]').val()}`,
            "name": `${_this.closest('[data-admission-support-form]').find('[name="full_name"]').val()}`,
            "email": `${_this.closest('[data-admission-support-form]').find('[name="email"]').val()}`,
            "current_city": `${_this.closest('[data-admission-support-form]').find('[name="city"]').val()}`,
            "current_academic_status": `${_this.closest('[data-admission-support-form]').find('[name="academic_status"]').val()}`,

            "preferred_country": `${_this.closest('[data-admission-support-form]').find('[name="preferred_country"]').val()}`,
            "preferred_intake": `${_this.closest('[data-admission-support-form]').find('[name="preferred_intake"]').val()}`,
            "preferred_course": `${_this.closest('[data-admission-support-form]').find('[name="preferred_course"]').val()}`,
            "has_loan_sanctioned": `${_this.closest('[data-admission-support-form]').find('[name="loan_sanctioned"]').val()}`,

            "english_test": `${_this.closest('[data-admission-support-form]').find('[name="english_test"]').val()}`,
            "pte_score": _this.closest('[data-admission-support-form]').find('[name="pte_score"]').length 
            ? _this.closest('[data-admission-support-form]').find('[name="pte_score"]').val() 
            : "",

            "pte_core_listening_clb_score": _this.closest('[data-admission-support-form]').find('[name="listening_clb"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="listening_clb"]').val()}` 
            : "",
            "pte_core_reading_clb_score": _this.closest('[data-admission-support-form]').find('[name="reading_clb"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="reading_clb"]').val()}` 
            : "",
            "pte_core_speaking_clb_score": _this.closest('[data-admission-support-form]').find('[name="speaking_clb"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="speaking_clb"]').val()}` 
            : "",
            "pte_core_writing_clb_score": _this.closest('[data-admission-support-form]').find('[name="writing_clb"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="writing_clb"]').val()}` 
            : "",

            "gre_verbal_reasoning_percentile": _this.closest('[data-admission-support-form]').find('[name="verbal_reasoning_percentile"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="verbal_reasoning_percentile"]').val()}` 
            : "",
            "gre_quantitative_reasoning_percentile": _this.closest('[data-admission-support-form]').find('[name="quantitative_reasoning_percentile"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="quantitative_quantitative_reasoning_percentilereasoning"]').val()}` 
            : "",
            "gre_analytical_writing_percentile":  _this.closest('[data-admission-support-form]').find('[name="analytical_writing_percentile"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="analytical_writing_percentile"]').val()}` 
            : "",

            "toefl_score": _this.closest('[data-admission-support-form]').find('[name="toefl_score"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="toefl_score"]').val()}` 
            : "",
            "ielts_band": _this.closest('[data-admission-support-form]').find('[name="ielts_score"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="ielts_score"]').val()}` 
            : "",
            "duolingo_score": _this.closest('[data-admission-support-form]').find('[name="duolingo_score"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="duolingo_score"]').val()}` 
            : "",
            "duo_exam_to_convert": _this.closest('[data-admission-support-form]').find('[name="duolingo_exam_list"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="duolingo_exam_list"]').val()}` 
            : "",
            "duo_convert_score": _this.closest('[data-admission-support-form]').find('[name="duo_convert_score"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="duo_convert_score"]').val()}` 
            : "",
            
            "message": `${_this.closest('[data-admission-support-form]').find('[name="message"]').val()}`,
            "source_url": window.location.href
        }
      }else if(_this.hasClass('data-accommodation-support')){
        var api = `https://edudialer.ekarostats.com/api/user/create_accomm`;
        var data = {
            "contact": `${_this.closest('[data-admission-support-form]').find('[name="phone_number"]').val()}`,
            "name": `${_this.closest('[data-admission-support-form]').find('[name="full_name"]').val()}`,
            "email": `${_this.closest('[data-admission-support-form]').find('[name="email"]').val()}`,
            "preferred_country": `${_this.closest('[data-admission-support-form]').find('[name="preferred_country"]').val()}`,
            "preferred_city": `${_this.closest('[data-admission-support-form]').find('[name="city"]').val()}`,
            "university_name": `${_this.closest('[data-admission-support-form]').find('[name="university_name"]').val()}`,
            "budget_range": `${_this.closest('[data-admission-support-form]').find('[name="budget_range"]').val()}`,

            "accommodation_type": `${_this.closest('[data-admission-support-form]').find('[name="type_of_accommodation"]').val()}`,
            "movein_date": `${_this.closest('[data-admission-support-form]').find('[name="movein_date"]').val()}`,
            "stay_duration": `${_this.closest('[data-admission-support-form]').find('[name="duration_of_stay"]').val()}`,
            "has_loan_sanctioned": `${_this.closest('[data-admission-support-form]').find('[name="loan_sanctioned"]').val()}`,

            "english_test": `${_this.closest('[data-admission-support-form]').find('[name="english_test"]').val()}`,
            "pte_score": _this.closest('[data-admission-support-form]').find('[name="pte_score"]').length 
            ? _this.closest('[data-admission-support-form]').find('[name="pte_score"]').val() 
            : "",

            "pte_core_listening_clb_score": _this.closest('[data-admission-support-form]').find('[name="listening_clb"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="listening_clb"]').val()}` 
            : "",
            "pte_core_reading_clb_score": _this.closest('[data-admission-support-form]').find('[name="reading_clb"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="reading_clb"]').val()}` 
            : "",
            "pte_core_speaking_clb_score": _this.closest('[data-admission-support-form]').find('[name="speaking_clb"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="speaking_clb"]').val()}` 
            : "",
            "pte_core_writing_clb_score": _this.closest('[data-admission-support-form]').find('[name="writing_clb"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="writing_clb"]').val()}` 
            : "",

            "gre_verbal_reasoning_percentile": _this.closest('[data-admission-support-form]').find('[name="verbal_reasoning_percentile"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="verbal_reasoning_percentile"]').val()}` 
            : "",
            "gre_quantitative_reasoning_percentile": _this.closest('[data-admission-support-form]').find('[name="quantitative_reasoning_percentile"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="quantitative_quantitative_reasoning_percentilereasoning"]').val()}` 
            : "",
            "gre_analytical_writing_percentile":  _this.closest('[data-admission-support-form]').find('[name="analytical_writing_percentile"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="analytical_writing_percentile"]').val()}` 
            : "",

            "toefl_score": _this.closest('[data-admission-support-form]').find('[name="toefl_score"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="toefl_score"]').val()}` 
            : "",
            "ielts_band": _this.closest('[data-admission-support-form]').find('[name="ielts_score"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="ielts_score"]').val()}` 
            : "",
            "duolingo_score": _this.closest('[data-admission-support-form]').find('[name="duolingo_score"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="duolingo_score"]').val()}` 
            : "",
            "duo_exam_to_convert": _this.closest('[data-admission-support-form]').find('[name="duolingo_exam_list"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="duolingo_exam_list"]').val()}` 
            : "",
            "duo_convert_score": _this.closest('[data-admission-support-form]').find('[name="duo_convert_score"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="duo_convert_score"]').val()}` 
            : "",
            
            "message": `${_this.closest('[data-admission-support-form]').find('[name="message"]').val()}`,
            "source_url": window.location.href
            
        }
      }else if(_this.hasClass('data-student-loan')){
        var api = `https://edudialer.ekarostats.com/api/user/create_st_loan`;
        var data = {
            "contact": `${_this.closest('[data-admission-support-form]').find('[name="phone_number"]').val()}`,
            "name": `${_this.closest('[data-admission-support-form]').find('[name="full_name"]').val()}`,
            "email": `${_this.closest('[data-admission-support-form]').find('[name="email"]').val()}`,
            "plan_to_study": `${_this.closest('[data-admission-support-form]').find('[name="plan_to_study"]').val()}`,
            "loan_amount": `${_this.closest('[data-admission-support-form]').find('[name="loan_amount"]').val()}`,
            "admission_status": `${_this.closest('[data-admission-support-form]').find('[name="admission_status"]').val()}`,

            "english_test": `${_this.closest('[data-admission-support-form]').find('[name="english_test"]').val()}`,
            "pte_score": _this.closest('[data-admission-support-form]').find('[name="pte_score"]').length 
            ? _this.closest('[data-admission-support-form]').find('[name="pte_score"]').val() 
            : "",

            "pte_core_listening_clb_score": _this.closest('[data-admission-support-form]').find('[name="listening_clb"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="listening_clb"]').val()}` 
            : "",
            "pte_core_reading_clb_score": _this.closest('[data-admission-support-form]').find('[name="reading_clb"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="reading_clb"]').val()}` 
            : "",
            "pte_core_speaking_clb_score": _this.closest('[data-admission-support-form]').find('[name="speaking_clb"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="speaking_clb"]').val()}` 
            : "",
            "pte_core_writing_clb_score": _this.closest('[data-admission-support-form]').find('[name="writing_clb"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="writing_clb"]').val()}` 
            : "",

            "gre_verbal_reasoning_percentile": _this.closest('[data-admission-support-form]').find('[name="verbal_reasoning_percentile"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="verbal_reasoning_percentile"]').val()}` 
            : "",
            "gre_quantitative_reasoning_percentile": _this.closest('[data-admission-support-form]').find('[name="quantitative_reasoning_percentile"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="quantitative_quantitative_reasoning_percentilereasoning"]').val()}` 
            : "",
            "gre_analytical_writing_percentile":  _this.closest('[data-admission-support-form]').find('[name="analytical_writing_percentile"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="analytical_writing_percentile"]').val()}` 
            : "",

            "toefl_score": _this.closest('[data-admission-support-form]').find('[name="toefl_score"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="toefl_score"]').val()}` 
            : "",
            "ielts_band": _this.closest('[data-admission-support-form]').find('[name="ielts_score"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="ielts_score"]').val()}` 
            : "",
            "duolingo_score": _this.closest('[data-admission-support-form]').find('[name="duolingo_score"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="duolingo_score"]').val()}` 
            : "",
            "duo_exam_to_convert": _this.closest('[data-admission-support-form]').find('[name="duolingo_exam_list"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="duolingo_exam_list"]').val()}` 
            : "",
            "duo_convert_score": _this.closest('[data-admission-support-form]').find('[name="duo_convert_score"]').length 
            ? `${_this.closest('[data-admission-support-form]').find('[name="duo_convert_score"]').val()}` 
            : "",
            
            "message": `${_this.closest('[data-admission-support-form]').find('[name="message"]').val()}`,
            "source_url": window.location.href
            
        }
      }
      console.log(data);
      fetch(api, {
        method: 'POST',
        headers: {
            'api_token': '8c87-48d2-8ee5-98ad8ebfeb4a',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(response => {
          if (!response.ok) {
              throw new Error('Network response was not ok ' + response.statusText);
          }
          return response.json();
      })
      .then(data => {
        console.log(data);

        _this.closest('.form-fields-wrapper').find('.input__field, select, .checkbox').each(function(index, field){
          $(field).val('');
          if ($(field).is('input')) {
            $(field).removeClass('is-filled');
            $(field).prop('checked', false);
          } else if ($(field).is('select')) {
            $(field).closest('.select-wrapper').removeClass('is-filled');
          }
          
        });

        $(this).before('<p class="form_success_msg">Thank you for submitting the form! Our team will reach out to you soon.</p>');
        $('[data-admissionform-submit]').hide();
        setTimeout(function(){
          $('.form_success_msg').remove();
          $('[data-admissionform-submit]').show();
        }, 4000);
        // console.log('this:');
        // $(this).next('.cart-popover').find('.cart-popover_resend-cont').html(`
        //     <svg width="92" height="88" viewBox="0 0 92 88" fill="none" xmlns="http://www.w3.org/2000/svg" class="">
        //       <path d="M91.8317 44L81.665 32.375L83.0817 17L68.04 13.5833L60.165 0.25L45.9984 6.33333L31.8317 0.25L23.9567 13.5417L8.91504 16.9167L10.3317 32.3333L0.165039 44L10.3317 55.625L8.91504 71.0417L23.9567 74.4583L31.8317 87.75L45.9984 81.625L60.165 87.7083L68.04 74.4167L83.0817 71L81.665 55.625L91.8317 44ZM38.04 63.6667L22.2067 47.7917L28.3734 41.625L38.04 51.3333L62.415 26.875L68.5817 33.0417L38.04 63.6667Z" fill="#26A651"/>      
        //     </svg>
        //     <div class="h6 resend-exam-voucher_popup-title"><strong>Voucher Successfully Sent</strong></div>
        //     <div>We’ve successfully sent your voucher to ${email} & ${phone}.</div>
        // `);
        // setTimeout(function(){
        //   $('.cart-popover').removeClass('active');
        // }, 10000); 
      })
      .catch(error => {
          console.error('Error:', error);
      });
    }
  });

  // Helper to show error messages
  function showError($field, message){
    $field.addClass("field-error");
    // let $error = $("<div class='error-message' style='color:red; font-size:12px; margin-top:4px;'>"+message+"</div>");
    // if($field.is(":checkbox")){
    //   $field.closest(".checkbox-container").append($error);
    // } else if($field.is("select")){
    //   $field.closest(".select-wrapper").after($error);
    // } else {
    //   $field.after($error);
    // }
  }



  if($('body').hasClass('template-cart')){

    if(localStorage.getItem('Achieve by taking this exam')){
      $('.cart-mandatory-field:not(.radio_custom)').removeClass('active');
      $(`.cart-mandatory-field.${localStorage.getItem('Achieve by taking this exam').replace(" ", "-").toLowerCase()}`).addClass('active');
      
      $('.cart-mandatory-field.popover_checkbox:not(.active) input[data-name]').each(function(i,_this) {
        $(_this).removeAttr("name");
      });
      $('.cart-mandatory-field.popover_radiobox:not(.active) input[data-name]').each(function(i,_this) {
        $(_this).removeAttr("name");
      });
      $('.cart-mandatory-field.checkbox_custom:not(.active) input[data-name]').each(function(i,_this) {
        $(_this).removeAttr("name");
      });
      
      $('.cart-mandatory-field.active:not(.radio_custom) input[data-name]').each(function(i,_this) {
        $(_this).attr("name",`attributes[${$(_this).attr("data-name")}]`)
      });
    }
    
    $('.cart-mandatory-field.radio_custom input[type="radio"]').each(function(i,_this) {
      if(localStorage.getItem($(_this).attr('data-name'))){      
        $('.cart-mandatory-details').removeClass($(this).attr('id'))
        if(localStorage.getItem($(_this).attr('data-name')) == $(_this).val()){
          $(this).attr('checked', true);
          $('.cart-mandatory-details').addClass($(this).attr('id'))
        }
      }
    });
    $('.cart-mandatory-field.popover_checkbox input[type="checkbox"]').each(function(i,_this) {
      if(localStorage.getItem($(this).closest('.cart-mandatory-field_main').find('.cart-mandatory-select').attr('data-name'))){
        var destinationArray = localStorage.getItem($(this).closest('.cart-mandatory-field_main').find('.cart-mandatory-select').attr('data-name')).split(",")
        if(localStorage.getItem($(this).closest('.cart-mandatory-field_main').find('.cart-mandatory-select').attr('data-name')).includes($(_this).val())){
          $(_this).attr('checked', true);
          $(this).closest('.cart-mandatory-field_main').find('.cart-mandatory-select:not(.cart-mandatory-select_show)').val($(_this).val());
          if(destinationArray.length > 1){
            $(this).closest('.cart-mandatory-field_main').find('.cart-mandatory-select_show').html(`${destinationArray[0]}<span> +${destinationArray.length - 1} more</span>`);
          }else{
            $(this).closest('.cart-mandatory-field_main').find('.cart-mandatory-select_show').html(destinationArray[0]);
          }
        }
      }
    });
    $('.cart-mandatory-field.popover_radiobox input[type="radio"]').each(function(i,_this) {
      if(localStorage.getItem($(_this).attr('data-name'))){      
        if(localStorage.getItem($(_this).attr('data-name')) == $(_this).val()){
          $(_this).attr('checked', true);
          $(this).closest('.cart-mandatory-field_main').find('.cart-mandatory-select').html($(_this).val()); 
        }
      }
    });
    $('.cart-mandatory-field.checkbox_custom input[type="checkbox"]').each(function(i,_this) {
      if(localStorage.getItem($(_this).attr('data-name'))){      
        if(localStorage.getItem($(_this).attr('data-name')) == 'true'){
          $(_this).attr('checked', true);
        }
      }
    });

    function checkfield(){
     var checkedcount = true;
      $('.cart .cart_fields_wrapper [name]').each(function(i,e){
        if($(e).closest('.cart-mandatory-field.active:not(.radio_custom)').hasClass('checkbox_custom')){
          if(!$(e).is(':checked')){
            checkedcount = false;
          }
        }else if($(e).closest('.cart-mandatory-field.active:not(.radio_custom)').hasClass('multi_checkbox')){   
          if($(e).closest('.cart-mandatory-field.active').find('.cart-mandatory-select').val() == ''){
            checkedcount = false;
          }
        }else if($(e).closest('.cart-mandatory-field.active:not(.radio_custom)').hasClass('multi_radiobox')){  
          if($('[name="'+$(e).attr('name')+'"]:checked').length == 0){
            checkedcount = false;
          }
        }
      });
      console.log('checkedcount',checkedcount);
      if(checkedcount){
        $('[name="checkout"]').removeAttr('disabled').removeClass('disabled');   
        $('.cart__checkout-button-wrapper').find('.cart-checkout_disabled-wrapper').remove();
        $('.cart__checkout-button-wrapper').find('.cart-checkout_error').remove();
      }else{
        $('[name="checkout"]').attr('disabled','disabled').addClass('disabled');
        if($('.cart__checkout-button-wrapper').find('.cart-checkout_error').length == 0){
          $('.cart__checkout-button-wrapper [name="checkout"]').after(`<a href="#cart-mandatory-details_main" class="cart-checkout_disabled-wrapper"></a><span class="cart-checkout_error text--xsmall" style="display:none;">Kindly fill all mandatory details</span>`)
        }
      } 
    }
    checkfield();
    $('body').on('change','.cart-mandatory-field.radio_custom input[type="radio"]', function(){
      $(".cart-mandatory-details").removeClass().addClass(`cart-mandatory-details ${$(this).attr('id')}`);
      localStorage.setItem($(this).attr('data-name'), $(this).val());

      $(`.cart-mandatory-field:not(.radio_custom) input[data-name]`).removeAttr("name");
      $($(`.cart-mandatory-field.${selected_type}:not(.radio_custom) [data-name]`)).map(function(i,__this) {
        $(__this).attr("name",`attributes[${$(__this).attr("data-name")}]`) 
      });

      var selected_type = $(this).attr('id');
      $(`.cart-mandatory-field.${selected_type}:not(.radio_custom)`).addClass('active');
      $(`.cart-mandatory-field:not(.radio_custom)`).removeClass('active');
      $(`.cart-mandatory-field.${selected_type}:not(.radio_custom)`).addClass('active');
      $(`.cart-mandatory-field:not(.radio_custom) [data-name]`).removeAttr("name");
      $($(`.cart-mandatory-field.${selected_type}:not(.radio_custom) [data-name]`)).map(function(i,__this) {
        $(__this).attr("name",`attributes[${$(__this).attr("data-name")}]`) 
      }); 
      checkfield();
    });
    $('body').on('change','.cart-mandatory-field.popover_checkbox input[type="checkbox"]', function(){
      if($(this).closest('.cart-mandatory-field_main').find('input[type="checkbox"]:checked').length > 0){
        var destinations = '';
        var first_selected_destination;
        var showing_destinations = '';
        var total_destinations_count;

        $($(this).closest('.cart-mandatory-field_main').find('input[type="checkbox"]:checked')).map(function(i,__this) {       
          total_destinations_count = i;
          if(i > 0){
            destinations += `, ${$(__this).val()}`
          }else{
            destinations += `${$(__this).val()}`
          }
  
          if(i >= 1){
            showing_destinations = `${first_selected_destination} <span> +${total_destinations_count} more</span>`
          }else{
            first_selected_destination = $(__this).val();
            showing_destinations = first_selected_destination;
          }
        });
         $(this).closest('.cart-mandatory-field_main').find('.cart-mandatory-select').val(destinations); 
         $(this).closest('.cart-mandatory-field_main').find('.cart-mandatory-select_show').html(showing_destinations); 
         console.log($(this).closest('.cart-mandatory-field_main').find('.cart-mandatory-select').attr('data-name'),destinations)
         localStorage.setItem($(this).closest('.cart-mandatory-field_main').find('.cart-mandatory-select').attr('data-name'), destinations);
      }else{
        $(this).closest('.cart-mandatory-field_main').find('.cart-mandatory-select').val(''); 
        $(this).closest('.cart-mandatory-field_main').find('.cart-mandatory-select_show').html('Choose'); 
        localStorage.removeItem($(this).closest('.cart-mandatory-field_main').find('.cart-mandatory-select').attr('data-name'));
      } 
      checkfield();
    });
    $('body').on('change','.cart-mandatory-field.popover_radiobox input[type="radio"]', function(){
      localStorage.setItem($(this).attr('data-name'), $(this).val());
      $(this).closest('.cart-mandatory-field_main').find('.cart-mandatory-select').text($(this).closest('.cart-mandatory-field_main').find('input[type="radio"]:checked').val());
      checkfield();
    });
    $('body').on('change','.cart-mandatory-field.checkbox_custom input[type="checkbox"]', function(){
      localStorage.setItem($(this).attr('data-name'), $(this).is(':checked'));
      checkfield();
    });

    $('.cart-checkout_disabled-wrapper').click(function(e){
      e.preventDefault();
      var target = this.hash;
      var $target = $(target);
      var _this = this;
       $(_this).next().show(); 
       $('.cart-mandatory-details_main').addClass('hilighted');
        $('html, body').stop().animate({
          'scrollTop': $target.offset().top-100
        });
       setTimeout(function(){
     	 $(_this).next().hide(); 
         $('.cart-mandatory-details_main').removeClass('hilighted');
       }, 2000);
    });
  }

  var $btn = $(".calculatore-fields-main .form_submit_btn");
  if($btn.length > 0){
    var rect = $btn.offset().top;

    $(window).on("load scroll", function () {
      var screenHeight = $(window).height();
      var scrolltop = $(window).scrollTop() + screenHeight;
      if (rect <= scrolltop) {
        // Button fully in view → normal
        $btn.removeClass("sticky");
      } else {
        // Button out of view (top/bottom) → sticky
        $btn.addClass("sticky");
      }
    });
  }
    
  

  function setCookie(name, value, days) {
    var d = new Date;
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }
  
  function applied_code(code, _this){
    // $('.dis_err_msg').remove();
    // $('#mini-cart').find('[name="discount"]').remove();
    // $('#mini-cart').find('.os_content_section .offers_list .offer_main_content .discount_cta_btn:not(.applied):not([disabled])').removeAttr('disabled').find('.btn_text').html('<span>Tap To Apply</span>');
    $.getJSON('/cart.js', function (cdata) {
      $.getJSON('/payments/config', function (data) {                      
          var main_check = {}, body_obj = {};
          body_obj.discount_code = code;
          body_obj.line_items = cdata.items;
          body_obj.presentment_currency = $('body').attr('data-currency');
          main_check.checkout = body_obj;
          main_check = JSON.stringify(main_check);
          $.ajax({
            type: "POST",
            url: "/wallets/checkouts/",
            dataType: 'json',
            async: false,
            data: main_check,
            headers: {
              "Content-Type": "application/json",
              "authorization": "Basic " + btoa(data.paymentInstruments.accessToken),
              "cache-control": "no-cache",
              "pragma": "no-cache",
              "Alt-Used": "https://assemblytravel.com/",
            },
            referrer: "https://assemblytravel.com/",
            credentials: "include",
            error: function (response){
                console.log(response);
                if(_this != null){
                  if($(_this).closest('.cart__coupon')){
                    $(_this).closest('.cart__coupon').append(`<p class="cart__applied_error-coupon_text text--xsmall">Invalid coupon</p>`);
                  }
                  if($(_this).closest('.discount_finder_item')){
                   $(_this).closest('.discount_finder_item').append(`<p class="cart__applied_error-coupon_text text--xsmall">Your coupon has been applied</p>`);
                  }                  
                }
                setTimeout(function(){
                  $('.cart__applied_error-coupon_text').remove();
                },40000);
                $(_this).removeClass('loading');
            },
            success: function (data) {  
              console.log('0000',data);      
              if(data.checkout.applied_discounts.length > 0){
                var cart = data.checkout;
                if($('.cart').find('.main_payment_card').length > 0){
                  var originaltotalprice = 0;
                  var total_saving = 0;
                  var vouchersaving = 0;
                  
                  if(cart.applied_discount.value_type == "percentage"){
                    var discountvalue = Math.floor(cart.applied_discount.value) + '%';
                  }else{
                    var discountvalue = formatMoney(Math.floor(cart.applied_discount.value), currencyFormat);
                  }                  
                                    
                  $(cart.line_items).each(function(i,e){
                    if(parseInt(e['compare_at_price']) > 0){
                      var original_compprice = parseInt(e['compare_at_price']) * parseInt(e['quantity']);
                      var diff = original_compprice - e['line_price'];
                      vouchersaving += parseInt(diff);                      
                    }       
                    var addition = parseInt(e['line_price']) + parseInt(diff);
                    console.log(e['line_price'], diff, addition)
                    originaltotalprice += parseInt(addition);
                  });
                  
                  total_saving += vouchersaving;
                  
                  var voucherhtml = '';
                  if(vouchersaving > 0){
                    var savings = Math.round(((originaltotalprice - cart.total_line_items_price) * 100) / originaltotalprice);                  
                    voucherhtml += `<div class="cart__total-container" bis_skin_checked="1">
                        <span class="h6">Voucher savings (${savings}%)</span>
                        <span class="h6 voucher-discount">- ${formatMoney(parseInt(vouchersaving) * 100, currencyFormat)}</span>
                      </div>`;      
                    
                  }
                  var discounthtml =  `<div class="cart__total-container cart_applied_discount" bis_skin_checked="1">
                        <span class="h6">Applied code (${discountvalue})</span>
                        <span class="h6 voucher-discount">- ${formatMoney(parseInt(cart.total_discount_amount) * 100, currencyFormat)}</span>
                      </div>`;  
                  total_saving += parseInt(cart.total_discount_amount);

                  if($(_this).hasClass('code-apply')){
                     var successboxhtml = `<div class="cart-popover_main-content">
                     <span class="code_applie_celebrating-wrapper">
                          <svg width="92" height="88" viewBox="0 0 92 88" fill="none" xmlns="http://www.w3.org/2000/svg" class="code_applie_celebrated">
                            <path d="M91.8317 44L81.665 32.375L83.0817 17L68.04 13.5833L60.165 0.25L45.9984 6.33333L31.8317 0.25L23.9567 13.5417L8.91504 16.9167L10.3317 32.3333L0.165039 44L10.3317 55.625L8.91504 71.0417L23.9567 74.4583L31.8317 87.75L45.9984 81.625L60.165 87.7083L68.04 74.4167L83.0817 71L81.665 55.625L91.8317 44ZM38.04 63.6667L22.2067 47.7917L28.3734 41.625L38.04 51.3333L62.415 26.875L68.5817 33.0417L38.04 63.6667Z" fill="#26A651"/>      
                          </svg>
                       </span>
                      <span class="coupon-popover_applied-code">‘${cart.applied_discount.title}’ applied</span>
                      <h5 class="coupon-popover_save_money h5">You saved ${formatMoney(parseInt(cart.total_discount_amount) * 100, currencyFormat)}</h5>
                      <span class="coupon-popover_save_money-text">with this code</span>
                    </div>`;
                    $('.code_applie_box .cart-popover_main-content').html(successboxhtml);
                    $('.code_applie_box').addClass('active');
                    setTimeout(function(){$('.code_applie_box').removeClass('active');}, 5000) 
                  }                  
                  
                   var paymentsummary = `<div class="cart__coupon" bis_skin_checked="1">
                    <h6 class="h6 cart__coupon-title">
                      <svg width="24" height="27" viewBox="0 0 24 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 0L14.7393 1.77664L18 1.6077L19.484 4.51598L22.3923 6L22.2234 9.26066L24 12L22.2234 14.7393L22.3923 18L19.484 19.484L18 22.3923L14.7393 22.2234L12 24L9.26066 22.2234L6 22.3923L4.51598 19.484L1.6077 18L1.77664 14.7393L0 12L1.77664 9.26066L1.6077 6L4.51598 4.51598L6 1.6077L9.26066 1.77664L12 0Z" fill="#022169"></path>
                        <g filter="url(#filter0_d_53_25369)">
                        <path d="M9.20651 11.5644C7.78925 11.5644 6.83051 10.4945 6.83051 9.13283C6.83051 7.75725 7.78925 6.67346 9.22041 6.67346C10.6655 6.67346 11.5964 7.77114 11.5964 9.11893C11.5964 10.4945 10.6238 11.5644 9.20651 11.5644ZM8.08104 16.3164L14.7227 6.77072H16.1956L9.55388 16.3164H8.08104ZM9.22041 10.3695C9.80399 10.3695 10.2347 9.88314 10.2347 9.11893C10.2347 8.38251 9.80399 7.8823 9.20651 7.8823C8.62293 7.8823 8.20609 8.36862 8.20609 9.11893C8.20609 9.86925 8.65072 10.3695 9.22041 10.3695ZM15.0423 16.4692C13.6111 16.4692 12.6524 15.3855 12.6524 14.0238C12.6524 12.6621 13.625 11.5783 15.0423 11.5783C16.4735 11.5783 17.4183 12.676 17.4183 14.0238C17.4183 15.3994 16.4318 16.4692 15.0423 16.4692ZM15.0423 15.2604C15.6398 15.2604 16.0566 14.7741 16.0566 14.0238C16.0566 13.2735 15.612 12.7732 15.0423 12.7732C14.4309 12.7732 14.0141 13.2596 14.0141 14.0238C14.0141 14.7602 14.4448 15.2604 15.0423 15.2604Z" fill="white"></path>
                        </g>
                        <defs>
                        <filter id="filter0_d_53_25369" x="1.77745" y="6.67188" width="20.6932" height="19.9021" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix>
                        <feOffset dy="5.05263"></feOffset>
                        <feGaussianBlur stdDeviation="2.52632"></feGaussianBlur>
                        <feComposite in2="hardAlpha" operator="out"></feComposite>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_53_25369"></feBlend>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_53_25369" result="shape"></feBlend>
                        </filter>
                        </defs>
                      </svg>
                      <span>Apply Coupon</span>
                    </h6>
                    <div class="cart__coupon-input input" bis_skin_checked="1">
                     <input type="text" id="code" name="code" class="input__field" value="${cart.applied_discount.title}">                     
                     <button type="button" class="input__label-action text--xxsmall code-remove">Remove</button>
                   </div>
                   <span class="cart__applied-coupon_text text--xsmall">Your coupon has been applied.</span>
                  </div><div class="payment_summery" bis_skin_checked="1">
                    <h6 class="h6 cart__total-title">Bill details</h6>
                    <div class="cart__recap-block cart__subtotal-block" bis_skin_checked="1">
                      <div class="cart__total-container" bis_skin_checked="1">
                        <span class="h6">Original price</span>
                        <span class="h6">${formatMoney(parseInt(originaltotalprice) * 100, currencyFormat)}</span>
                      </div>
                      ${voucherhtml}
                      ${discounthtml}
                    </div>
                    <div class="cart__recap-block" bis_skin_checked="1"><div class="cart__total-container" bis_skin_checked="1">
                        <span class="cart__total h6">Total</span>
                        <span class="cart__total-price h6">${formatMoney(parseInt(cart.total_price) * 100, currencyFormat)}</span>
                      </div>
                    </div>
  
                    <div class="cart__checkout-total-savings" bis_skin_checked="1">Your total savings ${formatMoney(parseInt(total_saving) * 100, currencyFormat)}</div>
                  </div>`;
                  
                  $('.cart').find('.main_payment_card').html(paymentsummary);
                  $('.cart__checkout-button .cart__checkout-button_text').html(`Pay ${formatMoney(parseInt(cart.total_price) * 100, currencyFormat)}`);
                }                
                $('form[action="/cart"] [name="discount"]').val(cart.discount_code);
                // $('form[action="/cart"]').prepend('<input type="hidden" name="discount" value="'+ cart.discount_code +'">');
                console.log('cart.discount_code',cart.discount_code);
                setCookie('discountcode',data.checkout.discount_code,100000);
              }else{
                console.log('error')
                $(_this).closest('.cart__coupon').append(`<p class="cart__applied_error-coupon_text text--xsmall">Invalid coupon</p>`);
                setTimeout(function(){
                  $('.cart__applied_error-coupon_text').remove();
                },40000);
                setCookie('discountcode',false,-1);
              }
              // $('body').addClass('discount_loaded');
            }
          });
       }); 
    });
  }

  //get cookie
  function getCookie(name) {
      var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
  }
  if(getCookie('discountcode')){
    if($('body').hasClass('checkout_has_discount') && document.referrer == 'https://eduvouchers.com/'){
      applied_code(getCookie('discountcode'));
    }else{
      setCookie('discountcode',false,-1);
    }
  }

  $('body').on('click','.cart .cart__coupon .code-apply', function(){
    // $(this).addClass('loading');
    applied_code($(this).closest('.cart__coupon').find('[name="code"]').val(), this);
  });

  $('body').on('click','.cart .cart__coupon .code-remove', function(){
    $('form[action="/cart"] [name="discount"]').val('0000!@#$%^&');
    setCookie('discountcode',false,-1);
    $.get('/cart', function (cdata) {
      $('.cart .main_payment_card').html($(cdata).find('.main_payment_card').html());
      $('.cart__checkout-button .cart__checkout-button_text').html($(cdata).find('.cart__checkout-button .cart__checkout-button_text').html());
    });
    location.reload();
  });

  $('body').on('click','.copy_code_text', function(){
    var couponText = $(this).attr('data-code');
    var tempInput = document.createElement("input");
    document.body.appendChild(tempInput);
    tempInput.value = couponText;
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
    $(this).addClass('copied');
    // Hide message after 2 seconds
    setTimeout(() => {
      $(this).removeClass('copied');        
    }, 4000);
  });

  if(document.getElementById('popup-4') && document.getElementById('custom-overlay-4')){  
    $('body').on('click','.download_resource', function(){
      document.getElementById('popup-4').style.display = 'block';
      document.getElementById('custom-overlay-4').style.display = 'block';
    });
  }

  $('.view-all-faq').click(function(){
   $(this).parents('.faq').find('.view-all_less-faq').toggle();
   $(this).parents('.faq').find('.faq__item.hidden-faq__item').show();
  });
  $('.view-less-faq').click(function(){
    $(this).parents('.faq').find('.view-all_less-faq').toggle();
    $(this).parents('.faq').find('.faq__item.hidden-faq__item').hide();
  });

  // $('.cms-tab_nav-link').click(function(e){
  //   e.preventDefault();
  //   $('.cms-tab_nav-link').removeClass('active');
  //   $(this).addClass('active');
  //   $('.cms-tab_content-item').hide();
    
  //   var activeTab = $(this).attr('href');
  //   $(activeTab).fadeIn();
  //   return false;
  // });

  $("#faq-searchbar_input__field").on("keyup", function() {
      var value = $(this).val().toLowerCase();
    $(".faq__item").filter(function() {
      $(this).toggle($(this).attr('question').toLowerCase().indexOf(value) > -1);  
        console.log('000',$(this).attr('question').toLowerCase().indexOf(value));
    });
  });

  if (window.matchMedia('(max-width: 999px)').matches){  
    $('.account-aside__orders-link').click(function(e){
     e.preventDefault();
     $('.account-aside').hide()
     $('.account_order-content').show();
     $('.account_order-back').show();
    });
    $('.account_order-back').click(function(e){
     e.preventDefault();
     $('.account-aside').show()
     $('.account_order-content').hide();
     $(this).hide();
    });
  }

  $('body').on('click','.traffic_source input[type="checkbox"]', function(){
    if($('.traffic_source input[type="checkbox"]:checked').length > 0){
      $('.traffic_source_input').show();
    }else{
      $('.traffic_source_input').hide();
    }
  });

  if($('.download_resource_btn').length > 0){
   $("body").on("click",'.download_resource_btn', function() {
    document.getElementById('popup-4').style.display = 'block';
    document.getElementById('custom-overlay-4').style.display = 'block';
   }); 
  }  

  $('body').on('click','[data-custom-formsubmit]', function (e) {
    e.preventDefault(); // Prevent form submission
    console.log('hihihihi');
    var __this = $(this);
     var _this = $(this).closest('.form-main-block');
    _this.find('.banner--error').hide();
    const phone = '91'+_this.find('[name="contact-number"]').val();
    const email = _this.find('[name="email"]').val();
    const name = _this.find('[name="name"]').val();
    const phoneRegex = /^[0-9]{12,15}$/; // Adjust for valid phone format
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    
    // Basic Validation
    if (!phoneRegex.test(phone)) {
      console.log('hihihihi');
      _this.find('[name="contact-number"]').closest('.input').append('<p class="banner--error">Please enter a valid 10 digit number without any space.</p>');
      return;
    }
    if (!emailRegex.test(email)) {
      _this.find('[name="email').closest('.input').append('<p class="banner--error">Please enter a valid email id.</p>');
      return;
    }

    $.ajax({
      url: "https://dev.d2cbox.com/shopify/api/v1/create_customer/",
      method: "POST",
      contentType:"application/json",
      headers: {
        "Authorization": "403dfac4c10e48bf9a6c5472f48dc407"
      },
      data: JSON.stringify({
        first_name: name,
        email: email,
        phone: phone,
        tag: __this.closest('.custom-popup').attr('data-popuptag')
      }),
      success: function (response) {
        console.log(response);
        var nextstep = parseInt(__this.closest('.stepblock').attr('data-step')) + 1;
        if(response.status == 1){          
          if(__this.closest('#popup-1').length > 0){
            __this.closest('.custom-popup').find('.stepblock[data-step="'+ nextstep +'"]').show();
            __this.closest('.stepblock').hide();
          }
          if(__this.closest('#popup-4').length == 0){          
            sessionStorage.setItem(__this.closest('.custom-popup'), 'true');
          }
        }else if(response.status == 0){
          _this.append('<p class="banner--error">'+response.message+'</p>');
        }else{
          _this.find('.banner--error .banner__content').html(response.message);
          _this.find('.banner--error').show();
        }
        if(__this.closest('#popup-1').length == 0){
          __this.closest('.custom-popup').find('.stepblock[data-step="'+ nextstep +'"]').show();
          __this.closest('.stepblock').hide();
        }
      },
      error: function (xhr, status, error) {
        console.log(xhr, status, error);
        // _this.find('.banner--error').show();
      }
    });
                 
  }); 

  if(document.getElementById("monthYearHidden")){

    const input = document.getElementById("monthYearInput");
    const hiddenInput = document.getElementById("monthYearHidden");
    const popup = document.getElementById("pickerPopup");
    const yearList = document.getElementById("yearList");
    const monthList = document.getElementById("monthList");
  
    const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth(); // 0 = Jan
    console.log(currentYear,'currentYear');
    let selectedYear = currentYear;
    let selectedMonth = currentMonth;
  
    function renderYears() {
      yearList.innerHTML = "";
      for (let y = currentYear; y <= currentYear + 5; y++) {
        const div = document.createElement("div");
        div.textContent = y;
        if (y === selectedYear) div.classList.add("active");
        div.onclick = () => {
          selectedYear = y;
          renderYears();
          renderMonths();
        };
        yearList.appendChild(div);
      }
    }
  
    function renderMonths() {
      monthList.innerHTML = "";
      months.forEach((m, i) => {
        const div = document.createElement("div");
        div.textContent = m;
  
        // Disable future months in the current year
        if (selectedYear === currentYear && i > currentMonth) {
          div.classList.add("disabled");
        }
  
        if (i === selectedMonth && selectedYear === currentYear) {
          div.classList.add("active");
        }
  
        div.onclick = () => {
          if (!div.classList.contains("disabled")) {
            selectedMonth = i;
            renderMonths();
            updateInput();
          }
        };
  
        monthList.appendChild(div);
      });
    }
  
    function updateInput() {
      if (selectedYear && selectedMonth !== null) {
        const displayVal = `${months[selectedMonth]} ${selectedYear}`;
        const hiddenVal = `${selectedYear}-${String(selectedMonth+1).padStart(2,"0")}`;
  
        input.value = displayVal;
        hiddenInput.value = displayVal;
        input.classList.add('is-filled');
        popup.style.display = "none"; // close after selection
      }
    }
  
    input.addEventListener("click", () => {
      popup.style.display = popup.style.display === "flex" ? "none" : "flex";
      renderYears();
      renderMonths();
    });
  
    document.addEventListener("click", (e) => {
      if (!e.target.closest(".month-year-picker")) {
        popup.style.display = "none";
      }
    });
  }

  $('body').on('click','.bundle_flex_wp .view_details_btn', function(){
    $('.bundle_overlay').addClass('active');
    $(this).closest('.bundle_flex_wp').find('.payment_summary_content').addClass('active');
  });
  $('body').on('click','.bundle_overlay', function(){
    $('.bundle_overlay').removeClass('active');
    $('.payment_summary_content').removeClass('active');
  });

  function summary_update(){
    var totlamnt = 0;
    var totlvoucheramnt = 0;
    var summaryhtml = ``;
    if($('.bundle_flex_wp .option-card input[type="radio"]:checked').length > 0){
      $('.bundle_flex_wp .option-card input[type="checkbox"]').removeAttr('disabled');
    }else{
      $('.bundle_flex_wp .option-card input[type="checkbox"]').attr('disabled',true);
    }
    $('.bundle_flex_wp .option-card input[type="radio"]:checked').each(function(i,e){
      totlamnt += parseInt($(e).attr('data-price'));
      console.log(parseInt($(e).attr('data-compprice')))
      console.log(parseInt($(e).attr('data-price')))
      
      totlvoucheramnt += parseInt($(e).attr('data-compprice')) - parseInt($(e).attr('data-price'))
      console.log(totlamnt)
      summaryhtml += `<div class="item_name" bis_skin_checked="1">
                          <span class="title">
                              ${$(e).attr('data-title')}
                          </span>
                          <span class="amount">   
                              ${formatMoney($(e).attr('data-compprice'), currencyFormat)}
                          </span>
                      </div>`;
    });
    var cnnt = 0;
    if($('.bundle_flex_wp .option-card input[type="checkbox"]:checked').length > 0){
      $('.bundle_flex_wp .option-card input[type="checkbox"]:checked').each(function(i,e){
        cnnt = cnnt + 1;
        totlamnt += parseInt($(e).attr('data-price'));
        totlvoucheramnt += parseInt($(e).attr('data-compprice')) - parseInt($(e).attr('data-price'))
        summaryhtml += `<div class="item_name" bis_skin_checked="1">
                            <span class="title">
                                ${$(e).attr('data-title')}
                            </span>
                            <span class="amount">   
                                ${formatMoney($(e).attr('data-compprice'), currencyFormat)}
                            </span>
                        </div>`;
      });
    }
    
    $('.payment_summary_content .payment_content_container').html(summaryhtml);
    console.log(cnnt);
    if(window.customthemeVariables.settings['discount'+cnnt]){
      var discount = parseInt(window.customthemeVariables.settings['discount'+cnnt]) * 100;
      totlamnt = totlamnt - discount;
      var discountstrip = totlvoucheramnt + discount;
      $('[data-bundlediscount]').html(formatMoney(discount, currencyFormat)).closest('.discount_strip').show();
      $('[data-discountstrip]').html(formatMoney(discountstrip, currencyFormat)).closest('.total_saving_note').show();
    }else{
      $('[data-bundlediscount]').closest('.discount_strip').hide();
      $('[data-discountstrip]').closest('.total_saving_note').hide();
    }
    document.documentElement.style.setProperty('--sticky_bundle_strip', document.querySelector('.bundle_atc_wrapper').clientHeight + 'px');
    $('[data-voucherdiscount]').html(formatMoney(totlvoucheramnt, currencyFormat))
    $('[data-totalamnt]').html(formatMoney(totlamnt, currencyFormat))
    if(totlamnt > 0){
      $('.bundle_right_content').attr('style','opacity: 1;visibility: visible;');
    }else{
      $('.bundle_right_content').attr('style','opacity: 0;visibility: hidden;');
    }
  }

  $('body').on('click','.variation_list_items .block-swatch__item', function(){
    window.location.href = $(this).attr('data-href');
  });

  $('body').on('change','.bundle_flex_wp [name="exam_voucher"]', function(){
    var pid = $(this).attr('data-pid');
    // const productJsonEl = document.getElementById('voucherJson');
    // const productData = JSON.parse(productJsonEl.textContent);

    // console.log(productData[pid].sub_items);
    // if(productData[pid].sub_items.length > 0){
    //   var optionshtml = ``;
    //   $(productData[pid].sub_items).each(function(i,e){
    //     if(e.available){
    //       if(e.compare_at_price > e.price){
    //         var savingamnt = e.compare_at_price - e.price;
    //       }
    //       optionshtml += `<div class="option-card">
    //                         <input type="checkbox" checked name="mock_test"
    //                             data-price="${e.price}"
    //                             data-compprice="${e.compare_at_price}"
    //                             data-title="${e.title}"
    //                             data-pid="${e.id}"
    //                             data-vid="${e.v_id}"
    //                         >
    //                         <div class="option-content">
    //                             <img src="${e.featured_image}&crop=center&height=150&v=1761284747&width=150" width="150" height="150" loading="lazy" alt="${e.title}">
    //                             <div class="option-info">
    //                                 <h4>${e.title}</h4>
    //                                 ${e.short_content ? `<p>${e.short_content}</p>` : ''}
    //                                 <div class="price_container">
    //                                     ${e.compare_at_price > e.price ? `<span class="compare_price">${formatMoney(e.compare_at_price, currencyFormat)}</span>` : ''}
    //                                     <span class="main_price">${formatMoney(e.price, currencyFormat)}</span>
    //                                     ${e.compare_at_price > e.price ? `<span class="save_amount">(Save: ${formatMoney(savingamnt, currencyFormat)})</span>` : ''}
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </div>`;
    //     }
    //   });
    //   $('.bundle-step[data-type="mocktest"] .bundle-option').html(optionshtml);
    //   $('.bundle-step[data-type="mocktest"]').show();
    // }else{
    //   $('.bundle-step[data-type="mocktest"] .bundle-option').html('');
    //   $('.bundle-step[data-type="mocktest"]').hide();
    // }
    summary_update();
  });

    $('body').on('change','.bundle_flex_wp [name="mock_test"]', function(){
      summary_update();
    });
  
  $('body').on('click','[data-bundleatc] ', function(){
    $(this).attr("aria-busy",true);
    var items = [];
    $(this).closest('.bundle_flex_wp').find('input[type="radio"]:checked,input[type="checkbox"]:checked').each(function(i,v){
      var val = $(this).attr('data-vid');         
       items.push({
        quantity: 1,
        id: val
      });   
    });    
    
    var data = {items};
    console.log('data',data)
    // var data = theme.utils.serialize(this.form);
   
    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function(data) {
      console.log(window.themeVariables.settings.pageType)    
      if (window.themeVariables.settings.pageType === "page") {
        window.location.href = '/cart';
        return;
      }else{
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        document.getElementById('mini-cart').open = true;
        $(this).removeAttr("aria-busy");
      } 
      
    }.bind(this));  
    
  });


});



if($('body').attr('template') == 'template-collection' && $('.collections-tabs_header-item').length > 0){
 var default_actie_tab = $('.collections-tabs_header-item').first().attr('href')
  $('.collections-tabs_header-item').first().addClass('active');
  $(`.collections-tabs-product_item:not([data-attr="${default_actie_tab}"])`).hide();
  $('.collections-tabs_header-item').click(function(e){
    e.preventDefault();
    $('.collections-tabs_header-item').removeClass('active');
    $('.collections-tabs-product_item').hide();
    $(this).addClass('active');
    
    var activeTab = $(this).attr('href');
    $(`.collections-tabs-product_item[data-attr="${activeTab}"]`).fadeIn();
    return false;
  }); 
}

document.addEventListener('DOMContentLoaded', function () {
  if(document.getElementById('mydateInput')){
    const input = document.getElementById('mydateInput');
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1; // e.g. 10 (months are 0-indexed)
    const currentDate = today.getDate();    
    const minDate = `${currentYear}-${currentMonth}-${currentDate}`;
    const maxDate = `${currentYear + 5}-12-31`;

    input.min = minDate;
    input.max = maxDate;
  }
  
});